class CollectionDescriptionToggle extends HTMLElement {
  connectedCallback() {
    
    if (this.classList.contains("disable-readmore")) return;
    this.shortBlock = this.querySelector(".short");
    this.fullBlock = this.querySelector(".full");
    this.toggleButton = this.querySelector(".read-more-button");
    this.readlessButton = this.querySelector('.read-less-button');
    this.toggleButton?.addEventListener("click", this.clickedReadMore.bind(this));
    this.readlessButton?.addEventListener("click", this.clickedReadLess.bind(this));

  }

  clickedReadMore() {
    this.shortBlock.classList.add('hide');
    this.fullBlock.classList.remove('hide');
  }
  clickedReadLess() {
    this.shortBlock.classList.remove('hide');
    this.fullBlock.classList.add('hide');
  }
}

customElements.define("collection-description-toggle", CollectionDescriptionToggle);
